import React from "react";
import "./styles.scss";

const Index = (props) => (
  <>
    <div className={`text-with-icon-wrapper d-flex  ${props.type} ${props.size}`} onClick={props.onClick}>
      <div className={"text-wrapper"}>{props.text}</div>
      {props.isIcon && <div className={"icon-wrapper"}>{props.icon}</div>}
    </div>
  </>
);
export default Index;
